/** Key codes as the short labels the Controls screen and help pages show. Pure. */

const NAMES: Readonly<Record<string, string>> = {
  ArrowUp: 'UP',
  ArrowDown: 'DOWN',
  ArrowLeft: 'LEFT',
  ArrowRight: 'RIGHT',
  Space: 'SPACE',
  Enter: 'ENTER',
  NumpadEnter: 'ENTER',
  Escape: 'ESC',
  Backspace: 'BKSP',
  Tab: 'TAB',
  ShiftLeft: 'SHIFT',
  ShiftRight: 'R.SHIFT',
  ControlLeft: 'CTRL',
  ControlRight: 'R.CTRL',
  AltLeft: 'ALT',
  AltRight: 'R.ALT',
  Minus: '-',
  Equal: '=',
  Comma: ',',
  Period: '.',
  Slash: '/',
  Semicolon: ';',
  Quote: "'",
  BracketLeft: '[',
  BracketRight: ']',
  Backslash: '\\',
  Backquote: '`',
};

export function keyName(code: string): string {
  if (code === '') return '---';
  const named = NAMES[code];
  if (named !== undefined) return named;
  if (/^Key[A-Z]$/.test(code)) return code.slice(3);
  if (/^Digit[0-9]$/.test(code)) return code.slice(5);
  if (/^Numpad[0-9]$/.test(code)) return `NUM${code.slice(6)}`;
  if (/^F[0-9]{1,2}$/.test(code)) return code;
  return code.toUpperCase().slice(0, 8);
}
